import { CheckCircleFilled, CopyOutlined } from '@ant-design/icons';
import { Button, Modal, message } from 'antd';
import kfQrCode from '../../../assets/kf.png';
import { copyText } from '../api';
import styles from './PaidModal.module.scss';

/**
 * 支付成功：展示客服二维码，引导用户添加客服并发送订单号获取精修后的文件。
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {string} props.orderNo
 * @param {boolean} [props.rush]
 * @param {() => void} props.onClose
 */
export default function PaidModal({ open, orderNo, rush, onClose }) {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={460}
            centered
            maskClosable={false}
            className={styles.modal}
        >
            <div className={styles.head}>
                <CheckCircleFilled className={styles.icon} />
                <h2 className={styles.title}>支付成功！</h2>
                <p className={styles.desc}>
                    请扫码添加客服，发送订单号 <b>{orderNo}</b> 获取精修后的文件
                </p>
            </div>

            <div className={styles.qrWrap}>
                <div className={styles.qrFrame}>
                    <img src={kfQrCode} alt="客服微信二维码" className={styles.qr} />
                </div>
                <p className={styles.qrHint}>微信扫一扫添加客服 · 手机上可长按或截图后在微信中识别</p>
            </div>

            <div className={styles.orderNo}>
                <span className={styles.orderNoLabel}>订单号</span>
                <span className={styles.orderNoValue}>{orderNo}</span>
                <Button
                    size="small"
                    type="primary"
                    ghost
                    icon={<CopyOutlined />}
                    onClick={() => copyText(orderNo, message)}
                >
                    复制
                </Button>
            </div>

            <ul className={styles.notes}>
                <li>{rush ? '加急订单 24 小时内交付' : '普通订单 48 小时内交付'}</li>
                <li>请保存好订单号，它是领取精修文件和售后的唯一凭证</li>
            </ul>

            <div className={styles.footer}>
                <Button type="primary" size="large" block onClick={onClose}>
                    我已添加客服
                </Button>
            </div>
        </Modal>
    );
}
